import { ASYNC_STATUS_ID } from 'constants'
import { API } from 'constants/apiEndPoints'
import { useUser } from 'hooks/user/useUser'
import { isEmpty } from 'lodash'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAPI } from 'utils/hooks/useAPI'

export const useHiLoGameLogic = () => {
  const { account } = useUser('wallet')
  const [gameData, setGameData] = useState({})
  const [updates, setUpdates] = useState(0)
  // OnLoad process
  const [hiloState, sendHiloQuery, hasHiloStatus, resetHiloStatus] = useAPI(API.GAMES_HIGH_LWO_CURRENT_GAME, {
    controlled: true,
    withJwt: true,
  })

  useEffect(() => {
    setGameData({ card: { suit: 'back', rank: '' } })
    sendHiloQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  useEffect(() => {
    if (hasHiloStatus(ASYNC_STATUS_ID.ERROR)) {
    }

    if (hasHiloStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      const data = hiloState?.data
      if (data.status === 'success') {
        const gameData = data?.data
        setGameData(gameData)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hiloState?.status])

  // on hit game

  const [hitState, sendHitQuery, hasHitStatus, resetHitStatus] = useAPI(API.GAMES_HIGH_LWO_HIT, {
    controlled: true,
    withJwt: true,
  })
  const hitGame = useCallback(
    (amount, prediction) => {
      sendHitQuery({ params: { amount, prediction }, tunnel: { prevCard: gameData.card } })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [gameData]
  )

  useEffect(() => {
    if (hasHitStatus(ASYNC_STATUS_ID.ERROR)) {
    }
    if (hasHitStatus(ASYNC_STATUS_ID.CONFIRMED)) {
      const data = hitState?.data
      if (data.status === 'success') {
        const gameData = data?.data
        const prevCard = data?.tunnel?.prevCard
        setGameData({ ...gameData, prevCard })
        setUpdates((prev) => prev + 1)
      }
      resetHitStatus()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hitState?.status])

  const isLoading = useMemo(() => isEmpty(gameData), [gameData])
  return { ...gameData, updates, isLoading, hitGame }
}
